export enum BannerVariant {
    DEFAULT = 'default',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    INFO = 'info',
    SIMPLE = 'simple'
}
